import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  title = 'Nutricia-Austria-Frontend';

  constructor(private readonly translateService: TranslateService) { }

  ngOnInit(): void {
    // Ensure default language is set to German
    // First, clear any existing language preference if it's English
    const savedLanguage = localStorage.getItem('language') ?? 'de';

    // If no saved language or if it's English, default to German
    const languageToUse = savedLanguage !== 'en' ? 'de' : 'en';

    // Set default language first
    this.translateService.setDefaultLang(languageToUse);

    // Then use the determined language
    this.translateService.use(languageToUse);

    // Update localStorage to ensure consistency
    localStorage.setItem('language', languageToUse);
  }
}
